export default __webpack_public_path__ + "static/media/the-enchanted-forest.d83e472d.png";